import request from "@/utils/request";

export const getUsers = () => request.get("/permissions/users");

export const getCurrentUser = () => request.get("/permissions/users/me");

export const getRoles = () => request.get("/permissions/roles");

export const getUserRoles = (userId) =>
  request.get(`/permissions/users/${userId}/roles`);

export const assignRole = (data) =>
  request.post("/permissions/assign-role", data);

export const reassignRole = (userId, data) =>
  request.post(`/permissions/users/${userId}/assign-role`, data);

export const assignPermissions = (data) =>
  request.post("/permissions/assign", data);

export const removeRole = (userId, data) =>
  request.post(`/permissions/users/${userId}/remove-role`, data);

export const removeAllRoles = (userId) =>
  request.post(`/permissions/users/${userId}/remove-all-roles`);

export const getUserApps = () => request.get("/user-apps");

export const createUserApp = (data) => request.post("/user-apps", data);

export const deleteUserApps = (data) => request.delete("/user-apps", { data });
